export const MONTH_DAY_YEAR_FORMAT = 'MMM DD, YYYY'; // example: Jan 01, 2020
export const SHORT_MONTH_SHORT_DAY_COMMA_YEAR_FORMAT = 'MMM DD, YYYY'; // example: Jan 01, 2020
export const MONTH_SHORT_DAY_YEAR_FORMAT = 'MMM D, YYYY'; // example: Jan 1, 2020
export const MONTH_DAY_FORMAT = 'MMM D'; // example: Jan 1
export const DAY_HOUR_MINUTE_FORMAT = 'ddd h:mm A'; // example: Mon 12:00 PM
export const MONTH_YEAR_FORMAT = 'MMMM YYYY'; // example: January 2020
export const YEAR_MONTH_FORMAT = 'YYYY-MM'; // example: 2020-01
export const SHORT_MONTH_YEAR_FORMAT = 'MMM YYYY'; // example: Jan 2020
export const SHORT_DAY_SHORT_MONTH_YEAR_FORMAT = 'DD MMM YYYY'; // example: 01 Jan 2020
export const SHORT_DAY_NUM_SHORT_MONTH_YEAR_FORMAT = 'D MMM YYYY'; // example: 1 Jan 2020
export const SHORT_MONTH_DAY_YEAR_FORMAT = 'MMM DD, YYYY'; // example: 01 January 2020
export const SHORT_MONTH_FORMAT = 'MMM'; // example: Jan
export const SHORT_DAY_FORMAT = 'dd'; // example: Mon
export const NUMERIC_DAY_MONTH_YEAR_FORMAT = 'DD-MM-YYYY'; // example: 01-01-2020
export const NUMERIC_DAY_MONTH_YEAR_DOTS_FORMAT = 'DD.MM.YYYY'; // example: 01.01.2020
export const NUMERIC_DAY_MONTH_SHORTEN_YEAR_DOTS_FORMAT = 'DD.MM.YY'; // example: 01.01.25
export const SHORT_MONTH_SHORT_DAY_COMMA_YEAR_DAY_HOUR_MINUTE_FORMAT =
  'MMM DD, YYYY h:mm A'; // example: Jan 01, 2020 12:00 PM
export const SHORT_MONTH_ORDINAL_DAY_COMMA_YEAR_24HOUR_FORMAT =
  'MMM Do, YYYY, HH:mm'; // example: May 13th, 2025, 15:00
export const DURATION_MINUTES_SECONDS_FORMAT = 'mm:ss'; // example: 02:30
export const SHORT_MONTH_SHORT_DAY_YEAR_TIME_FORMAT = 'MMM D, YYYY, HH:mm'; // example: Jan 1, 2020, 12:00
export const DURATION_MINUTES_SECONDS_MILLISECONDS_FORMAT = 'm:ss.SSS'; // example: 2:30.000
export const TIME_HOUR_MINUTE_WITH_AM_PM_FORMAT = 'h:mm a'; // example: 2:30 pm
